module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/dom-serializer/node_modules/entities/lib/maps/xml.json
// module id = 738
// module chunks = 0 1 2 3 4 5 6 7